import React, { useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { Skeleton, Divider, Alert, Table, Row, Col, Button } from "antd";
import { arrayOf, string, func } from "prop-types";

import {
  getVisitReportsHistoricQuery,
  getFieldbookQuery,
} from "@graphql/queries";
import { useCreateVisitReport } from "@graphql/mutations";
import { formatDate } from "@utils/dateUtils";

const tableProps = {
  size: "middle",
  pagination: false,
};

function FieldbookVisitReportsHistoric({
  fieldbookId,
  producersIds,
  afterSubmit,
}) {
  const [create] = useCreateVisitReport();
  const mappedIds = producersIds.map(id => id);
  const [selectedRows, setSelectedRows] = useState([]);
  const queryVars = { variables: { where: mappedIds } };
  const { data, error, loading } = useQuery(getVisitReportsHistoricQuery, {
    ...queryVars,
  });
  const rowSelection = {
    onChange: (_, selectedRows) => setSelectedRows(selectedRows),
  };
  const columns = [
    {
      dataIndex: "date",
      title: "Data",
      render: formatDate,
    },
    {
      dataIndex: "intervention",
      title: "Intervenção / Doença / Praga / Infestante detectada acima do NEA",
    },
    {
      dataIndex: "recommendedActiveSubstance",
      title: "Substância Ativa Recomendada",
    },
  ];

  const createMultiple = () => {
    selectedRows.map(fields => {
      const { date, intervention, recommendedActiveSubstance } = fields;
      const refetchQueries = [
        {
          query: getFieldbookQuery,
          variables: { id: fieldbookId },
        },
      ].filter(Boolean);

      return create({
        variables: {
          data: {
            fieldbook: {
              connect: { id: fieldbookId },
            },
            date,
            intervention,
            recommendedActiveSubstance,
          },
        },
        refetchQueries,
      }).then(() => afterSubmit());
    });
  };

  if (loading) return <Skeleton />;
  if (error) {
    return (
      <Alert
        message="Algo correu mal"
        description={
          <pre>
            <code>{JSON.stringify(error, null, 2)}</code>
          </pre>
        }
        type="error"
        showIcon
      />
    );
  }

  return (
    <>
      {data?.fieldbooks.map(({ id, portion, visitReports }) => (
        <div key={id}>
          <Divider>Parcela: {portion.name}</Divider>

          <Table
            columns={columns}
            dataSource={visitReports}
            rowKey={({ id }) => id}
            pagination={false}
            rowSelection={{
              ...rowSelection,
            }}
            {...tableProps}
          />
        </div>
      ))}

      <Row style={{ marginTop: 30, textAlign: "center" }}>
        <Col span={24}>
          <Button
            type="primary"
            disabled={selectedRows.length < 1}
            onClick={createMultiple}
          >
            {selectedRows.length > 0
              ? `Copiar ${selectedRows.length} relatórios de visita`
              : `Selecione relatórios de visita`}
          </Button>
        </Col>
      </Row>
    </>
  );
}

FieldbookVisitReportsHistoric.propTypes = {
  fieldbookId: string.isRequired,
  producersIds: arrayOf(string).isRequired,
  afterSubmit: func.isRequired,
};

export default FieldbookVisitReportsHistoric;
